module.exports = __webpack_public_path__ + "static/media/plexusAnimateClosing.976fd3e9.gif";